// File: apps/web/src/components/pwa/InstallPrompt.tsx

import { useEffect, useState } from 'react';
import { hasInstallPrompt, promptInstall, isRunningAsPWA } from '../../utils/serviceWorker';

export function InstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Don't show if already running as PWA or previously dismissed
    if (isRunningAsPWA()) return;
    if (localStorage.getItem('pwa-install-dismissed')) return;

    // Check if install prompt is available
    const checkPrompt = () => {
      if (hasInstallPrompt()) {
        setShowPrompt(true);
      }
    };

    // Listen for install prompt ready event
    window.addEventListener('pwainstallready', checkPrompt);

    // Check immediately in case event already fired
    checkPrompt();

    // Listen for app installed event
    const handleInstalled = () => {
      setShowPrompt(false);
    };
    window.addEventListener('pwainstalled', handleInstalled);

    return () => {
      window.removeEventListener('pwainstallready', checkPrompt);
      window.removeEventListener('pwainstalled', handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    const installed = await promptInstall();
    if (installed) {
      setShowPrompt(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!showPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-50 animate-slide-up">
      <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-red-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-white font-semibold mb-1">Install ROAM Sports</h3>
            <p className="text-sm text-gray-400 mb-3">
              Add to your home screen for quick access and offline features.
            </p>
            <div className="flex gap-2">
              <button
                onClick={handleInstall}
                className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-500 transition-colors"
              >
                Install
              </button>
              <button
                onClick={handleDismiss}
                className="px-4 py-2 bg-neutral-700 text-gray-300 text-sm font-medium rounded-lg hover:bg-neutral-600 transition-colors"
              >
                Not Now
              </button>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
